import { Pipe, PipeTransform } from '@angular/core';
import { Option } from './select.component';

@Pipe({
  name: 'toOptions'
})
export class ToOptionsPipe implements PipeTransform {

  transform(value: any[], map: Option): any {
    return value.map(item => {
      return {
        title: item[map.title],
        value: item[map.value]
      };
    });
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/select/to-options.pipe.ts